import { render, staticRenderFns } from "./StockImage.vue?vue&type=template&id=06a2b393&scoped=true&"
import script from "./StockImage.vue?vue&type=script&lang=js&"
export * from "./StockImage.vue?vue&type=script&lang=js&"
import style0 from "./StockImage.vue?vue&type=style&index=0&id=06a2b393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a2b393",
  null
  
)

export default component.exports